import { Bookmark } from 'lucide-react';
import { cn } from '@/shared/lib/utils/cn';
import { useAuth, useAuthModal } from '@/features/auth';
import { useArticleSave, useToggleSave } from '../api/useSave';

/** Save/bookmark toggle. Signed-out clicks open the auth modal. */
export function SaveButton({ articleId }: { articleId: string }) {
  const { user } = useAuth();
  const openAuth = useAuthModal((state) => state.open);
  const { data: saved } = useArticleSave(articleId);
  const toggle = useToggleSave(articleId);
  const isSaved = saved ?? false;

  const handleClick = () => {
    if (!user) {
      openAuth('login');
      return;
    }
    toggle.mutate(isSaved);
  };

  return (
    <button
      type="button"
      aria-pressed={isSaved}
      onClick={handleClick}
      className={cn(
        'flex items-center gap-2 rounded-full border px-4 py-2 text-sm font-medium transition-all',
        isSaved
          ? 'border-amber-400 bg-amber-50 text-amber-700 dark:bg-amber-950/30 dark:text-amber-300'
          : 'border-border text-muted-foreground hover:border-zinc-300 hover:text-foreground dark:hover:border-zinc-600',
      )}
    >
      <Bookmark className={cn('h-4 w-4', isSaved && 'fill-current')} />
      {isSaved ? 'Saved' : 'Save'}
    </button>
  );
}
